import React, { ReactNode } from 'react';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { FinishComponentView, selectCompensationIdx, deathCompensationExists } from './FinishComponentView';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { WprRowInfo } from '../../wpr-framework/component/props/WprRowInfo';
import { FooterComponent } from '../common/footer/FooterComponent';
// import './Finish.css';

/**
 * 契約手続き完了コンポーネント
 */
class FinishComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new FinishComponentView(), props);
	}
	// --------------------------------------------------------------------------
	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>5</span></li>
								<li className="done"><span>6</span></li>
								<li className="done"><span>7</span></li>
								<li className="now"><span>8</span>
									<p className="conf double" id="step8">ご契約手続き<br className="c-sm-br" />完了</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<main className="page-finish">
					<div className="top">
						<h1>ありがとうございます、保険契約の手続きが完了しました</h1>
						<p>ご登録いただいたメールアドレス宛に申込み完了メールをお送りしました。契約確認用のURLも記載していますので、あわせてご確認ください。</p>
						<div className="attention">
							<p className="c-quest-s">をクリックすると説明が表示されます。</p>
						</div>

					</div>
					<div className="info">
						<section>
							<h2 className="c-headline">ログイン情報</h2>
							<div className="wrap-login c-list">
								<p>保険契約証のURLからログインをする際に必要となります。</p>
								<dl>
									<dt><span>ログインID</span>
										<WprButton className="c-quest-b" name="q-loginId" view={this.view}></WprButton>
									</dt>
									<dd><WprSpan name='loginId' view={this.view}></WprSpan></dd>
								</dl>
								<p className="pass-imp">※パスワードは個人情報登録時に決めていただいたもの</p>
							</div>
						</section>
						<section>
							<h2 className="c-headline">基本情報</h2>
							<div className="wrap-basic c-list">
								<dl>
									<dt>契約証番号</dt>
									<dd><WprSpan name='contractNumber' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>保険種類</dt>
									<dd><WprSpan name='insuranceType' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>契約プラン</dt>
									<dd><WprSpan name='plan' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>合計保険料（全員分）</dt>
									<dd><WprSpan name='insuranceFee' view={this.view} converter='3桁カンマ'></WprSpan>円</dd>
								</dl>
								<dl>
									<dt>保険期間</dt>
									<dd><WprSpan name='insurancePeriod' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>申込日</dt>
									<dd><WprSpan name='applicationDate' view={this.view}></WprSpan></dd>
								</dl>
							</div>
							<div className="wrap-content c-list">
								<div className="c-tit">
									<h3>補償内容</h3>
								</div>
								{this.renderList('CollateralInfo')}
							</div>
							<div className="wrap-covenant c-list">
								<div className="c-tit">
									<h3>特約・約款</h3>
								</div>
								<p><WprSpan name='specialProvision' view={this.view}></WprSpan></p>
							</div>
						</section>
						<section>
							<h2 className="c-headline">契約者（申込者）情報</h2>
							<div className="wrap-contractor c-list">
								<dl>
									<dt>契約者名</dt>
									<dd><WprSpan name='lastNameContractor' view={this.view}></WprSpan>　<WprSpan name='firstNameContractor' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>契約者名（ローマ字）</dt>
									<dd><WprSpan name='romanLastNameContractor' view={this.view}></WprSpan>　<WprSpan name='romanFirstNameContractor' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>生年月日</dt>
									<dd><WprSpan name='yearContractor' view={this.view}></WprSpan>年<WprSpan name='monthContractor' view={this.view}></WprSpan>月<WprSpan name='dateContractor' view={this.view}></WprSpan>日</dd>
								</dl>
								<dl>
									<dt>性別</dt>
									<dd><WprSpan name='genderContractor' view={this.view} converter='性別'></WprSpan></dd>
								</dl>
								<dl>
									<dt>住所</dt>
									<dd className="address">〒<WprSpan name='postalCode' view={this.view} converter='郵便番号'></WprSpan>　<WprSpan name='prefecture' view={this.view}></WprSpan><WprSpan name='address1' view={this.view}></WprSpan>　<WprSpan name='address2' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>電話番号</dt>
									<dd><WprSpan name='tel' view={this.view}></WprSpan></dd>
								</dl>
								<dl>
									<dt>メールアドレス</dt>
									<dd><WprSpan name='mailAddress' view={this.view}></WprSpan></dd>
								</dl>
							</div>
						</section>
						<section>
							{this.renderList('TravelerInfo')}
						</section>
						<section>
							<h2 className="c-headline">告知事項</h2>
							<div className="kokuchijikou">
								<div className="c-tit">
									<h3>下記内容をご確認ください</h3>
								</div>
								<ol>
									{this.renderList('ContractNoticeInfo')}
								</ol>
								<div className="imp">
									<div className="wrap">
										<p>*危険な仕事および運動については、「重要事項説明書」の注意喚起情報　告知義務・通知義務の項目ご覧ください。</p>
										<p> ☆★の項目は、ご契約に際して保険会社がおたずねする特に重要な事項（告知事項）。</p>
										<p>★印の項目は、ご契約後に変更が生じた際に保険会社にご連絡をいただく必要のある事項（通知事項）です。</p>
										<p>ご回答が事実と相違している場合には、保険契約を解除する場合や、保険金をお支払いできない場合がありますのでご注意ください。</p>
									</div>
								</div>
							</div>
							<div className="all-yes"><span>全て「はい」</span></div>
						</section>
						<section className="other">
							<h2 className="c-headline">その他</h2>
							<div className="wrap-other">
								<div className="wrap-annotation">
									<p>チューリッヒ保険会社御中</p>
									<p>次の項目について確認・同意の上、本保険プランに申込みます。</p>
									<ul>
										<li>普通保険約款、特約および[重要事項説明書（契約概要/注意喚起情報）]の内容</li>
										<li>重要事項説明書に記載の[申込内容チェックシート（意向確認書）]の内容</li>
										<li>この入力確認画面の記載事項は事実に相違がないこと</li>
										<li>この入力確認画面に記載の個人情報が取扱代理店および引受保険会社へ提供・通知され、引受保険会社にて保護・管理されること</li>
									</ul>
								</div>
								<dl>
									<dt>引受保険会社</dt>
									<dd><span>チューリッヒ保険会社</span></dd>
								</dl>
								<dl>
									<dt>取扱代理店</dt>
									<dd><WprSpan name='agency' view={this.view}></WprSpan></dd>
								</dl>
							</div>
						</section>
					</div>
				</main>
				<WprContainer mode="q-loginId" view={this.view}>
					<div className="c-layer">
						<div className="box">
							<h1>ログインID</h1>
							<p>
								旅行保険契約照会サイトにログインして契約内容をご確認いただく際に必要となります。
							</p>
							<WprButton className="button" name="close" view={this.view}>
								<span>閉じる</span>
							</WprButton>
						</div>
					</div>
				</WprContainer>
				<FooterComponent />
			</>
		);
	}

	/**
	 * リスト描画
	 * @param listName リスト名
	 * @param rowInfo 行情報
	 */
	protected onRenderList(listName: string, rowInfo: WprRowInfo): any {
		if (listName === 'TravelerInfo') {
			return (
				<div key={rowInfo.index}>
					{/* <div className="traveler01"> */}
					<h2 className="c-headline">
						旅行者（記名被保険者）-{this.zenkaku(rowInfo.index + 1)} 情報
					</h2>
					<div className="wrap-traveler01 c-list">
						<dl>
							<dt>被保険者名（ローマ字）</dt><dd className="c-input">
								<WprSpan name='romanLastNameTraveler' view={this.view} row={rowInfo}></WprSpan>　<WprSpan name='romanFirstNameTraveler' view={this.view} row={rowInfo}></WprSpan>
							</dd>
						</dl>
						<dl>
							<dt>生年月日</dt>
							<dd>
								<WprSpan name='yearTraveler' view={this.view} row={rowInfo}></WprSpan>年<WprSpan name='monthTraveler' view={this.view} row={rowInfo}></WprSpan>月<WprSpan name='dateTraveler' view={this.view} row={rowInfo}></WprSpan>日
							</dd>
						</dl>
						<dl>
							<dt>性別</dt>
							<dd>
								<WprSpan name='genderTraveler' view={this.view} converter='性別' row={rowInfo}></WprSpan>
							</dd>
						</dl>
						{this.showRecipient()}
					</div>
				</div>
			);
		}
		if (listName === 'ContractNoticeInfo') {
			return (
				<li key={rowInfo.index}>
					<WprSpan name="noticeMessage" view={this.view} row={rowInfo}></WprSpan>
				</li>
			);
		}
		if (listName === 'CollateralInfo') {
			return (
				<dl key={rowInfo.index}>
					<dt>
						<WprSpan name="collateralName" view={this.view} row={rowInfo} />
						<WprButton className="c-quest-b" name="question" view={this.view} row={rowInfo}></WprButton>
					</dt>
					<dd><WprSpan name='collateralAmount' view={this.view} row={rowInfo}></WprSpan></dd>
					{this.showHelp(rowInfo.index, rowInfo)}
				</dl>
			);
		}
		return null;
	}
	// --------------------------------------------------------------------------

	// 数字の半角→全角変換
	private zenkaku(num: number) {
		return String(num).replace(/[0-9]/g, function (s: string) {
			return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
		});
	}
	/**
	 * 補償ヘルプモーダル表示
	 * @param index 
	 * @param rowInfo 
	 */
	private showHelp(index: number, rowInfo: any) {
		// if (selectCompensationIdx === null)
		// 	return '';
		// if (index !== Number(selectCompensationIdx))
		// 	return '';
		return (<WprContainer mode={rowInfo.rowData.collateralKey} view={this.view} >
			<div className="c-layer">
				<div className="box" key={rowInfo.index}>
					<h1><WprSpan name="displayCollateralName" view={this.view} row={rowInfo} /></h1>
					<p><WprSpan name="collateralDescription" view={this.view} row={rowInfo} /></p>
					<WprButton className="button" name="close" view={this.view}>
						<span>閉じる</span>
					</WprButton>
				</div>
			</div>
		</WprContainer >);
	}
	/**
	 * 死亡保険受取人表示
	 * @param index 
	 * @param rowInfo 
	 */
	private showRecipient() {
		if (deathCompensationExists) {
			return (
				<dl>
					<dt>死亡保険金受取人</dt>
					<dd>
						<span>死亡保険受取人は、被保険者の法定相続人となります</span>
					</dd>
				</dl>);
		}
		else
			return '';
	}
}
export default withRouter(FinishComponent);